<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../../app.logic";
  import FormField from "../../../components/Form/FormField.svelte";
  import FormLayout from "../../../layout/FormLayout.svelte";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import type { IApiResponse } from "../../../utils/api/api-response";
  import { initDetail, record, save, uploading } from "./quality-waste.store";
  import type { IQualityWaste } from "../../../entities/quality-waste";
  import NumberInput from "../../../components/Form/Fields/NumberInput.svelte";
  import Label from "../../../components/Form/Label.svelte";
  import FileUploadButton from "../../../components/FileUploadButton.svelte";
  import { StoredFileService } from "../../../services/stored-file.service";
  import { get } from "svelte/store";
  import Button from "../../../components/Button.svelte";
  import DateInputString from "../../../components/Form/Fields/DateInputString.svelte";
  import Input from "../../../components/Form/Fields/Input.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit = $record != null && !!$record.documentDate && !!$record.description && !!$record.storedFileId;
  $: canEdit = $record != null && $record.oid == 0;

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IQualityWaste> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/quality-waste/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/quality-waste`);
  }

  async function uploadFile(event: CustomEvent<File>) {
    uploading.set(true);
    try {
      const file: File = event.detail;
      let _res = await StoredFileService.uploadStoredFile(file);
      let fileId = _res.payload.oid;
      let _rec = get(record);
      record.set(<IQualityWaste>{ ..._rec, storedFileId: fileId });
    } finally {
      uploading.set(false);
    }
  }

  async function onDownloadFile(item: IQualityWaste) {
    StoredFileService.downloadStoredFile(item.storedFileId);
  }

  onMount(() => initDetail(oid));
</script>

<QualityLayout>
  {#if $record}
    <div class="columns" style="margin-top:1rem;">
      <div class="column is-12">
        <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
          <div class="columns">
            <div class="column is-4">
              <FormField>
                <DateInputString name="Data Documento" placeholder="" required={true} bind:value={$record.documentDate} />
              </FormField>
            </div>
            <div class="column is-8">
              <Input name="Descrizione" required={true} bind:value={$record.description} />
            </div>
          </div>

          <div class="columns">
            <div class="column is-4">
              <FormField>
                <NumberInput name="KG Cat.3" placeholder="" bind:value={$record.cat3Kg} />
              </FormField>
            </div>
            <div class="column is-4">
              <FormField>
                <NumberInput name="KG Cat.2" placeholder="" bind:value={$record.cat2Kg} />
              </FormField>
            </div>
            <div class="column is-4">
              {#if isNew}
                <FormField>
                  <Label>&nbsp;</Label>
                  <div>
                    <FileUploadButton text="Carica allegato..." disabled={$uploading} on:fileUpload={uploadFile} />
                    {#if $uploading}
                      <i class="material-icons">hourglass_bottom</i>
                    {:else if $record.storedFileId > 0}
                      <i class="material-icons">check</i>
                    {:else}
                      <i class="material-icons">close</i>
                    {/if}
                  </div>
                </FormField>
              {:else}
                <FormField>
                  <Label>&nbsp;</Label>
                  <div>
                    <Button on:click={(_) => onDownloadFile($record)}>Scarica allegato</Button>
                  </div>
                </FormField>
              {/if}
            </div>
          </div>
        </FormLayout>
      </div>
    </div>
  {/if}
</QualityLayout>
